import { path } from 'ramda';

import { useAppSelector } from '@core/js/store/hooks';
import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

export const useIsShowTag = (type: TAG_TYPE_BUZZ) => {
    return useAppSelector(path(['showTagsList', type]));
};
